const IconsFoundationsZiniaThemes = {
    'icon_arrow_down-thick': 'icon_arrow_down-thick.svg ',
    'icon_arrow_down': 'icon_arrow_down.svg ',
    'icon_arrow_download': 'icon_arrow_download.svg ',
    'icon_arrow_fits-creen': 'icon_arrow_fits-creen.svg ',
    'icon_arrow_full-screen-enter': 'icon_arrow_full-screen-enter.svg ',
    'icon_arrow_full-screen-exit': 'icon_arrow_full-screen-exit.svg ',
    'icon_arrow_full-screen': 'icon_arrow_full-screen.svg ',
    'icon_arrow_input': 'icon_arrow_input.svg ',
    'icon_arrow_left-thick': 'icon_arrow_left-thick.svg ',
    'icon_arrow_left': 'icon_arrow_left.svg ',
    'icon_arrow_non-renewable': 'icon_arrow_non-renewable.svg ',
    'icon_arrow_recycling': 'icon_arrow_recycling.svg ',
    'icon_arrow_refresh': 'icon_arrow_refresh.svg ',
    'icon_arrow_renovation': 'icon_arrow_renovation.svg ',
    'icon_arrow_return-back-thick': 'icon_arrow_return-back-thick.svg ',
    'icon_arrow_return-back': 'icon_arrow_return-back.svg ',
    'icon_arrow_return-thick': 'icon_arrow_return-thick.svg ',
    'icon_arrow_return': 'icon_arrow_return.svg ',
    'icon_arrow_right-left': 'icon_arrow_right-left.svg ',
    'icon_arrow_right-thick': 'icon_arrow_right-thick.svg ',
    'icon_arrow_right': 'icon_arrow_right.svg ',
    'icon_arrow_share': 'icon_arrow_share.svg ',
    'icon_arrow_shuffle': 'icon_arrow_shuffle.svg ',
    'icon_arrow_sign-in': 'icon_arrow_sign-in.svg ',
    'icon_arrow_sign-off': 'icon_arrow_sign-off.svg ',
    'icon_arrow_sprint': 'icon_arrow_sprint.svg ',
    'icon_arrow_strategy': 'icon_arrow_strategy.svg ',
    'icon_arrow_trade': 'icon_arrow_trade.svg ',
    'icon_arrow_up-down': 'icon_arrow_up-down.svg ',
    'icon_arrow_up-thick': 'icon_arrow_up-thick.svg ',
    'icon_arrow_up': 'icon_arrow_up.svg ',
    'icon_arrow_update': 'icon_arrow_update.svg ',
    'icon_arrow_upload': 'icon_arrow_upload.svg ',
    'icon_arrow_first-to-last': 'icon_arrow_first-to-last.svg',
    'icon_arrow_last-to-first': 'icon_arrow_last-to-first.svg',
    'icon_brand_ehl': 'icon_brand_ehl.svg ',
    'icon_brand_logo': 'icon_brand_logo.svg ',
    'icon_brand_now': 'icon_brand_now.svg ',
    'icon_brand_placeholder': 'icon_brand_placeholder.svg ',
    'icon_card_basic-card': 'icon_card_basic-card.svg ',
    'icon_card_block': 'icon_card_block.svg ',
    'icon_card_change-associate-account': 'icon_card_change-associate-account.svg ',
    'icon_card_check-pin': 'icon_card_check-pin.svg ',
    'icon_card_click-to-pay': 'icon_card_click-to-pay.svg ',
    'icon_card_configuration': 'icon_card_configuration.svg ',
    'icon_card_cvv-number': 'icon_card_cvv-number.svg ',
    'icon_card_direct-money': 'icon_card_direct-money.svg ',
    'icon_card_discount': 'icon_card_discount.svg ',
    'icon_card_e-card': 'icon_card_e-card.svg ',
    'icon_card_e-cash': 'icon_card_e-cash.svg ',
    'icon_card_enter-e-cash': 'icon_card_enter-e-cash.svg ',
    'icon_card_extract': 'icon_card_extract.svg ',
    'icon_card_gift-card': 'icon_card_gift-card.svg ',
    'icon_card_id-card': 'icon_card_id-card.svg ',
    'icon_card_info-card': 'icon_card_info-card.svg ',
    'icon_card_insert': 'icon_card_insert.svg ',
    'icon_card_loyalty': 'icon_card_loyalty.svg ',
    'icon_card_mobile-payment': 'icon_card_mobile-payment.svg ',
    'icon_card_modify-liquidation-method': 'icon_card_modify-liquidation-method.svg ',
    'icon_card_multiple': 'icon_card_multiple.svg ',
    'icon_card_operate-without-card': 'icon_card_operate-without-card.svg ',
    'icon_card_postpone-liquidation': 'icon_card_postpone-liquidation.svg ',
    'icon_card_subscriptions-cards': 'icon_card_subscriptions-cards.svg ',
    'icon_card_swift-cards': 'icon_card_swift-cards.svg ',
    'icon_card_unblock-card': 'icon_card_unblock-card.svg ',
    'icon_card_withdraw-e-cash': 'icon_card_withdraw-e-cash.svg ',
    'icon_categories_atm': 'icon_categories_atm.svg ',
    'icon_categories_currency-exchange': 'icon_categories_currency-exchange.svg ',
    'icon_categories_education-and-health': 'icon_categories_education-and-health.svg ',
    'icon_categories_exclusive-movements-dollar': 'icon_categories_exclusive-movements-dollar.svg ',
    'icon_categories_exclusive-movements-euro': 'icon_categories_exclusive-movements-euro.svg ',
    'icon_categories_expenses': 'icon_categories_expenses.svg ',
    'icon_categories_gift': 'icon_categories_gift.svg ',
    'icon_categories_group': 'icon_categories_group.svg ',
    'icon_categories_home': 'icon_categories_home.svg ',
    'icon_categories_income': 'icon_categories_income.svg ',
    'icon_categories_investments-and-savings': 'icon_categories_investments-and-savings.svg ',
    'icon_categories_leisure-and-travel': 'icon_categories_leisure-and-travel.svg ',
    'icon_categories_organizations-and-ongs': 'icon_categories_organizations-and-ongs.svg ',
    'icon_categories_other-expenses-dollar': 'icon_categories_other-expenses-dollar.svg ',
    'icon_categories_other-expenses-euro': 'icon_categories_other-expenses-euro.svg ',
    'icon_categories_other-expenses': 'icon_categories_other-expenses.svg ',
    'icon_categories_pending': 'icon_categories_pending.svg ',
    'icon_categories_professional-expenses': 'icon_categories_professional-expenses.svg ',
    'icon_categories_restaurants': 'icon_categories_restaurants.svg ',
    'icon_categories_shopping': 'icon_categories_shopping.svg ',
    'icon_categories_transfers': 'icon_categories_transfers.svg ',
    'icon_categories_transports': 'icon_categories_transports.svg ',
    'icon_chart_analysis': 'icon_chart_analysis.svg ',
    'icon_chart_bank-fees': 'icon_chart_bank-fees.svg ',
    'icon_chart_bars': 'icon_chart_bars.svg ',
    'icon_chart_broker-plataform': 'icon_chart_broker-plataform.svg ',
    'icon_chart_burn-down-bars': 'icon_chart_burn-down-bars.svg ',
    'icon_chart_burn-down-graph': 'icon_chart_burn-down-graph.svg ',
    'icon_chart_candle-stick': 'icon_chart_candle-stick.svg ',
    'icon_chart_european-bars': 'icon_chart_european-bars.svg ',
    'icon_chart_green-asset': 'icon_chart_green-asset.svg ',
    'icon_chart_pie-chart': 'icon_chart_pie-chart.svg ',
    'icon_chart_quotations': 'icon_chart_quotations.svg ',
    'icon_chart_sitemap': 'icon_chart_sitemap.svg ',
    'icon_chart_steps': 'icon_chart_steps.svg ',
    'icon_chart_stock-exchange': 'icon_chart_stock-exchange.svg ',
    'icon_chart_sustainability-linked-loans': 'icon_chart_sustainability-linked-loans.svg ',
    'icon_chevron_down-fit': 'icon_chevron_down-fit.svg ',
    'icon_chevron_down-small-fit': 'icon_chevron_down-small-fit.svg ',
    'icon_chevron_down-small-thick-fit': 'icon_chevron_down-small-thick-fit.svg ',
    'icon_chevron_down-small-thick': 'icon_chevron_down-small-thick.svg ',
    'icon_chevron_down-small': 'icon_chevron_down-small.svg ',
    'icon_chevron_down-thick-fit': 'icon_chevron_down-thick-fit.svg ',
    'icon_chevron_down-thick': 'icon_chevron_down-thick.svg ',
    'icon_chevron_down': 'icon_chevron_down.svg ',
    'icon_chevron_left-fit': 'icon_chevron_left-fit.svg ',
    'icon_chevron_left-small-fit': 'icon_chevron_left-small-fit.svg ',
    'icon_chevron_left-small-thick-fit': 'icon_chevron_left-small-thick-fit.svg ',
    'icon_chevron_left-small-thick': 'icon_chevron_left-small-thick.svg ',
    'icon_chevron_left-small': 'icon_chevron_left-small.svg ',
    'icon_chevron_left-thick-fit': 'icon_chevron_left-thick-fit.svg ',
    'icon_chevron_left-thick': 'icon_chevron_left-thick.svg ',
    'icon_chevron_left': 'icon_chevron_left.svg ',
    'icon_chevron_right-fit': 'icon_chevron_right-fit.svg ',
    'icon_chevron_right-small-fit': 'icon_chevron_right-small-fit.svg ',
    'icon_chevron_right-small-thick-fit': 'icon_chevron_right-small-thick-fit.svg ',
    'icon_chevron_right-small-thick': 'icon_chevron_right-small-thick.svg ',
    'icon_chevron_right-small': 'icon_chevron_right-small.svg ',
    'icon_chevron_right-thick-fit': 'icon_chevron_right-thick-fit.svg ',
    'icon_chevron_right-thick': 'icon_chevron_right-thick.svg ',
    'icon_chevron_right': 'icon_chevron_right.svg ',
    'icon_chevron_up-down-fit': 'icon_chevron_up-down-fit.svg ',
    'icon_chevron_up-down': 'icon_chevron_up-down.svg ',
    'icon_chevron_up-fit': 'icon_chevron_up-fit.svg ',
    'icon_chevron_up-small-fit': 'icon_chevron_up-small-fit.svg ',
    'icon_chevron_up-small-thick-fit': 'icon_chevron_up-small-thick-fit.svg ',
    'icon_chevron_up-small-thick': 'icon_chevron_up-small-thick.svg ',
    'icon_chevron_up-small': 'icon_chevron_up-small.svg ',
    'icon_chevron_up-thick-fit': 'icon_chevron_up-thick-fit.svg ',
    'icon_chevron_up-thick': 'icon_chevron_up-thick.svg ',
    'icon_chevron_up': 'icon_chevron_up.svg ',
    'icon_communication_announcement': 'icon_communication_announcement.svg ',
    'icon_communication_business-support': 'icon_communication_business-support.svg ',
    'icon_communication_call-support': 'icon_communication_call-support.svg ',
    'icon_communication_chat': 'icon_communication_chat.svg ',
    'icon_communication_contact-center': 'icon_communication_contact-center.svg',
    'icon_communication_email': 'icon_communication_email.svg ',
    'icon_communication_help': 'icon_communication_help.svg ',
    'icon_communication_inbox': 'icon_communication_inbox.svg ',
    'icon_communication_message': 'icon_communication_message.svg ',
    'icon_communication_no-messages': 'icon_communication_no-messages.svg ',
    'icon_communication_notification-settings': 'icon_communication_notification-settings.svg ',
    'icon_communication_phone-24h': 'icon_communication_phone-24h.svg ',
    'icon_communication_phone-call': 'icon_communication_phone-call.svg ',
    'icon_communication_phone-support': 'icon_communication_phone-support.svg ',
    'icon_communication_phone': 'icon_communication_phone.svg ',
    'icon_communication_send': 'icon_communication_send.svg ',
    'icon_communication_speeches': 'icon_communication_speeches.svg ',
    'icon_communication_videochat': 'icon_communication_videochat.svg ',
    'icon_communication_videoconference': 'icon_communication_videoconference.svg ',
    'icon_communication_whatsapp-trade': 'icon_communication_whatsapp-trade.svg ',
    'icon_communication_whatsapp': 'icon_communication_whatsapp.svg ',
    'icon_currency_american-dolar-iso': 'icon_currency_american-dolar-iso.svg ',
    'icon_currency_argentine-peso-iso': 'icon_currency_argentine-peso-iso.svg ',
    'icon_currency_atm-dollar': 'icon_currency_atm-dollar.svg ',
    'icon_currency_atm-euro': 'icon_currency_atm-euro.svg ',
    'icon_currency_atm-pound': 'icon_currency_atm-pound.svg ',
    'icon_currency_bag-money-dollar': 'icon_currency_bag-money-dollar.svg ',
    'icon_currency_bag-money-euro': 'icon_currency_bag-money-euro.svg ',
    'icon_currency_bag-money-pound': 'icon_currency_bag-money-pound.svg ',
    'icon_currency_balboa': 'icon_currency_balboa.svg ',
    'icon_currency_bolivar': 'icon_currency_bolivar.svg ',
    'icon_currency_boliviano-iso': 'icon_currency_boliviano-iso.svg ',
    'icon_currency_boliviano': 'icon_currency_boliviano.svg ',
    'icon_currency_bonus-dollar': 'icon_currency_bonus-dollar.svg ',
    'icon_currency_bonus-euro': 'icon_currency_bonus-euro.svg ',
    'icon_currency_bonus-pound': 'icon_currency_bonus-pound.svg ',
    'icon_currency_brazilian-real-iso': 'icon_currency_brazilian-real-iso.svg ',
    'icon_currency_change-account-associate-dollar': 'icon_currency_change-account-associate-dollar.svg ',
    'icon_currency_change-account-associate-euro': 'icon_currency_change-account-associate-euro.svg ',
    'icon_currency_change-account-associate-pound': 'icon_currency_change-account-associate-pound.svg ',
    'icon_currency_checking-account-change': 'icon_currency_checking-account-change.svg ',
    'icon_currency_checking-account-closing': 'icon_currency_checking-account-closing.svg ',
    'icon_currency_checking-account-open': 'icon_currency_checking-account-open.svg ',
    'icon_currency_checking-account': 'icon_currency_checking-account.svg ',
    'icon_currency_chilean-peso-iso': 'icon_currency_chilean-peso-iso.svg ',
    'icon_currency_chilean-uf-iso': 'icon_currency_chilean-uf-iso.svg ',
    'icon_currency_chilean-unidad-fomento-iso': 'icon_currency_chilean-unidad-fomento-iso.svg ',
    'icon_currency_colombian-peso-iso': 'icon_currency_colombian-peso-iso.svg ',
    'icon_currency_colon': 'icon_currency_colon.svg ',
    'icon_currency_confirming-advances-dollar': 'icon_currency_confirming-advances-dollar.svg ',
    'icon_currency_confirming-advances-euro': 'icon_currency_confirming-advances-euro.svg ',
    'icon_currency_confirming-advances-pound': 'icon_currency_confirming-advances-pound.svg ',
    'icon_currency_cordoba': 'icon_currency_cordoba.svg ',
    'icon_currency_dollar-bill': 'icon_currency_dollar-bill.svg ',
    'icon_currency_dollar-symbol': 'icon_currency_dollar-symbol.svg ',
    'icon_currency_dollar': 'icon_currency_dollar.svg ',
    'icon_currency_email-invoice-dollar': 'icon_currency_email-invoice-dollar.svg ',
    'icon_currency_email-invoice-euro': 'icon_currency_email-invoice-euro.svg ',
    'icon_currency_email-invoice-pound': 'icon_currency_email-invoice-pound.svg ',
    'icon_currency_euro-bill-note': 'icon_currency_euro-bill-note.svg ',
    'icon_currency_euro-iso': 'icon_currency_euro-iso.svg ',
    'icon_currency_euro-symbol': 'icon_currency_euro-symbol.svg ',
    'icon_currency_euro': 'icon_currency_euro.svg ',
    'icon_currency_exhange': 'icon_currency_exhange.svg ',
    'icon_currency_factoring-dollar': 'icon_currency_factoring-dollar.svg ',
    'icon_currency_factoring-euro': 'icon_currency_factoring-euro.svg ',
    'icon_currency_factoring-pound': 'icon_currency_factoring-pound.svg ',
    'icon_currency_finance-purchase-dollar': 'icon_currency_finance-purchase-dollar.svg ',
    'icon_currency_finance-purchase-euro': 'icon_currency_finance-purchase-euro.svg ',
    'icon_currency_finance-purchase-pound': 'icon_currency_finance-purchase-pound.svg ',
    'icon_currency_gourde': 'icon_currency_gourde.svg ',
    'icon_currency_group-dollar': 'icon_currency_group-dollar.svg ',
    'icon_currency_group-euro': 'icon_currency_group-euro.svg ',
    'icon_currency_group-pound': 'icon_currency_group-pound.svg ',
    'icon_currency_guarani': 'icon_currency_guarani.svg ',
    'icon_currency_lempira': 'icon_currency_lempira.svg ',
    'icon_currency_levy-received-dollar': 'icon_currency_levy-received-dollar.svg ',
    'icon_currency_levy-received-euro': 'icon_currency_levy-received-euro.svg ',
    'icon_currency_levy-received-pound': 'icon_currency_levy-received-pound.svg ',
    'icon_currency_levy-sent-dollar': 'icon_currency_levy-sent-dollar.svg ',
    'icon_currency_levy-sent-euro': 'icon_currency_levy-sent-euro.svg ',
    'icon_currency_levy-sent-pound': 'icon_currency_levy-sent-pound.svg ',
    'icon_currency_management-dollar': 'icon_currency_management-dollar.svg ',
    'icon_currency_management-euro': 'icon_currency_management-euro.svg ',
    'icon_currency_management-pound': 'icon_currency_management-pound.svg ',
    'icon_currency_money-cash-dollar': 'icon_currency_money-cash-dollar.svg ',
    'icon_currency_money-cash-euro': 'icon_currency_money-cash-euro.svg ',
    'icon_currency_money-cash-pound': 'icon_currency_money-cash-pound.svg ',
    'icon_currency_mortgages-dollar': 'icon_currency_mortgages-dollar.svg ',
    'icon_currency_mortgages-euro': 'icon_currency_mortgages-euro.svg ',
    'icon_currency_mortgages-pound': 'icon_currency_mortgages-pound.svg ',
    'icon_currency_one-time-payment-dollar': 'icon_currency_one-time-payment-dollar.svg ',
    'icon_currency_one-time-payment-euro': 'icon_currency_one-time-payment-euro.svg ',
    'icon_currency_one-time-payment-pound': 'icon_currency_one-time-payment-pound.svg ',
    'icon_currency_online-value-dollar': 'icon_currency_online-value-dollar.svg ',
    'icon_currency_online-value-euro': 'icon_currency_online-value-euro.svg ',
    'icon_currency_online-value-pound': 'icon_currency_online-value-pound.svg ',
    'icon_currency_payment-dollar': 'icon_currency_payment-dollar.svg ',
    'icon_currency_payment-euro': 'icon_currency_payment-euro.svg ',
    'icon_currency_payment-pound': 'icon_currency_payment-pound.svg ',
    'icon_currency_payment-progress-dollar': 'icon_currency_payment-progress-dollar.svg ',
    'icon_currency_payment-progress-euro': 'icon_currency_payment-progress-euro.svg ',
    'icon_currency_payment-progress-pound': 'icon_currency_payment-progress-pound.svg ',
    'icon_currency_paysheet-dollar': 'icon_currency_paysheet-dollar.svg ',
    'icon_currency_paysheet-euro': 'icon_currency_paysheet-euro.svg ',
    'icon_currency_paysheet-pound': 'icon_currency_paysheet-pound.svg ',
    'icon_currency_portability': 'icon_currency_portability.svg ',
    'icon_currency_pound-iso': 'icon_currency_pound-iso.svg ',
    'icon_currency_pound-note': 'icon_currency_pound-note.svg ',
    'icon_currency_pound-symbol': 'icon_currency_pound-symbol.svg ',
    'icon_currency_pound': 'icon_currency_pound.svg ',
    'icon_currency_price': 'icon_currency_price.svg ',
    'icon_currency_quetzal': 'icon_currency_quetzal.svg ',
    'icon_currency_real': 'icon_currency_real.svg ',
    'icon_currency_recurrent-payment-dollar': 'icon_currency_recurrent-payment-dollar.svg ',
    'icon_currency_recurrent-payment-euro': 'icon_currency_recurrent-payment-euro.svg ',
    'icon_currency_recurrent-payment-pound': 'icon_currency_recurrent-payment-pound.svg ',
    'icon_currency_redemption-dollar': 'icon_currency_redemption-dollar.svg ',
    'icon_currency_redemption-euro': 'icon_currency_redemption-euro.svg ',
    'icon_currency_redemption-pound': 'icon_currency_redemption-pound.svg ',
    'icon_currency_remittances-dollar': 'icon_currency_remittances-dollar.svg ',
    'icon_currency_remittances-euro': 'icon_currency_remittances-euro.svg ',
    'icon_currency_remittances-pound': 'icon_currency_remittances-pound.svg ',
    'icon_currency_saving-account-dollar': 'icon_currency_saving-account-dollar.svg ',
    'icon_currency_saving-account-euro': 'icon_currency_saving-account-euro.svg ',
    'icon_currency_saving-account-pound': 'icon_currency_saving-account-pound.svg ',
    'icon_currency_schedule-payment-dollar': 'icon_currency_schedule-payment-dollar.svg ',
    'icon_currency_schedule-payment-euro': 'icon_currency_schedule-payment-euro.svg ',
    'icon_currency_schedule-payment-pound': 'icon_currency_schedule-payment-pound.svg ',
    'icon_currency_schedule-spending-dollar': 'icon_currency_schedule-spending-dollar.svg ',
    'icon_currency_schedule-spending-euro': 'icon_currency_schedule-spending-euro.svg ',
    'icon_currency_schedule-spending-pound': 'icon_currency_schedule-spending-pound.svg ',
    'icon_currency_search-dollar': 'icon_currency_search-dollar.svg ',
    'icon_currency_search-euro': 'icon_currency_search-euro.svg ',
    'icon_currency_search-pound': 'icon_currency_search-pound.svg ',
    'icon_currency_sol-iso': 'icon_currency_sol-iso.svg ',
    'icon_currency_sol': 'icon_currency_sol.svg ',
    'icon_currency_statements-dollar': 'icon_currency_statements-dollar.svg ',
    'icon_currency_statements-euro': 'icon_currency_statements-euro.svg ',
    'icon_currency_statements-pound': 'icon_currency_statements-pound.svg ',
    'icon_currency_uruguayan-peso-iso': 'icon_currency_uruguayan-peso-iso.svg ',
    'icon_currency_venezuelan-bolivar-soberano-iso': 'icon_currency_venezuelan-bolivar-soberano-iso.svg ',
    'icon_currency_withdraw-dollar': 'icon_currency_withdraw-dollar.svg ',
    'icon_currency_withdraw-euro': 'icon_currency_withdraw-euro.svg ',
    'icon_currency_withdraw-pound': 'icon_currency_withdraw-pound.svg ',
    'icon_currency_won': 'icon_currency_won.svg ',
    'icon_currency_yen-iso': 'icon_currency_yen-iso.svg ',
    'icon_currency_yen': 'icon_currency_yen.svg ',
    'icon_currency_yuan-iso': 'icon_currency_yuan-iso.svg ',
    'icon_currency_yuan': 'icon_currency_yuan.svg ',
    'icon_devices_android': 'icon_devices_android.svg ',
    'icon_devices_app-santander': 'icon_devices_app-santander.svg ',
    'icon_devices_atm': 'icon_devices_atm.svg ',
    'icon_devices_calculator': 'icon_devices_calculator.svg ',
    'icon_devices_card-machine': 'icon_devices_card-machine.svg ',
    'icon_devices_decrease': 'icon_devices_decrease.svg ',
    'icon_devices_desktop-chrome': 'icon_devices_desktop-chrome.svg ',
    'icon_devices_desktop': 'icon_devices_desktop.svg ',
    'icon_devices_digital-channels': 'icon_devices_digital-channels.svg ',
    'icon_devices_digital-subscriptions-contactless': 'icon_devices_digital-subscriptions-contactless.svg ',
    'icon_devices_digital-subscriptions': 'icon_devices_digital-subscriptions.svg ',
    'icon_devices_increase': 'icon_devices_increase.svg ',
    'icon_devices_ios': 'icon_devices_ios.svg ',
    'icon_devices_laptop': 'icon_devices_laptop.svg ',
    'icon_devices_mobile-chart': 'icon_devices_mobile-chart.svg ',
    'icon_devices_mobile-landscape': 'icon_devices_mobile-landscape.svg ',
    'icon_devices_mobile-message': 'icon_devices_mobile-message.svg ',
    'icon_devices_mobile-top-up': 'icon_devices_mobile-top-up.svg ',
    'icon_devices_mobile': 'icon_devices_mobile.svg ',
    'icon_devices_mouse': 'icon_devices_mouse.svg ',
    'icon_devices_nfc-bracelet': 'icon_devices_nfc-bracelet.svg ',
    'icon_devices_nfc-sticker': 'icon_devices_nfc-sticker.svg ',
    'icon_devices_nfc': 'icon_devices_nfc.svg ',
    'icon_devices_old-version': 'icon_devices_old-version.svg ',
    'icon_devices_radio': 'icon_devices_radio.svg ',
    'icon_devices_smartwatch-payment': 'icon_devices_smartwatch-payment.svg ',
    'icon_devices_smartwatch': 'icon_devices_smartwatch.svg ',
    'icon_devices_tv': 'icon_devices_tv.svg ',
    'icon_devices_videogames-switch': 'icon_devices_videogames-switch.svg ',
    'icon_devices_videogames': 'icon_devices_videogames.svg ',
    'icon_documents_add-calendar': 'icon_documents_add-calendar.svg ',
    'icon_documents_appointments': 'icon_documents_appointments.svg ',
    'icon_documents_attach-document': 'icon_documents_attach-document.svg ',
    'icon_documents_attachment': 'icon_documents_attachment.svg ',
    'icon_documents_backlog': 'icon_documents_backlog.svg ',
    'icon_documents_bdr': 'icon_documents_bdr.svg ',
    'icon_documents_book': 'icon_documents_book.svg ',
    'icon_documents_bookmark': 'icon_documents_bookmark.svg ',
    'icon_documents_calendar': 'icon_documents_calendar.svg ',
    'icon_documents_cancel-appointments': 'icon_documents_cancel-appointments.svg ',
    'icon_documents_card-invoice': 'icon_documents_card-invoice.svg ',
    'icon_documents_change-contributions': 'icon_documents_change-contributions.svg ',
    'icon_documents_checklist': 'icon_documents_checklist.svg ',
    'icon_documents_clipboard': 'icon_documents_clipboard.svg ',
    'icon_documents_cms': 'icon_documents_cms.svg ',
    'icon_documents_contacts': 'icon_documents_contacts.svg ',
    'icon_documents_copy': 'icon_documents_copy.svg ',
    'icon_documents_cv': 'icon_documents_cv.svg ',
    'icon_documents_definition-done': 'icon_documents_definition-done.svg ',
    'icon_documents_definition-ready': 'icon_documents_definition-ready.svg ',
    'icon_documents_details': 'icon_documents_details.svg ',
    'icon_documents_doc': 'icon_documents_doc.svg ',
    'icon_documents_document': 'icon_documents_document.svg ',
    'icon_documents_epic': 'icon_documents_epic.svg ',
    'icon_documents_etf': 'icon_documents_etf.svg ',
    'icon_documents_faq': 'icon_documents_faq.svg ',
    'icon_documents_file-transfer': 'icon_documents_file-transfer.svg ',
    'icon_documents_file': 'icon_documents_file.svg ',
    'icon_documents_folder': 'icon_documents_folder.svg ',
    'icon_documents_gift-ticket': 'icon_documents_gift-ticket.svg ',
    'icon_documents_image-unavailable': 'icon_documents_image-unavailable.svg ',
    'icon_documents_image': 'icon_documents_image.svg ',
    'icon_documents_incomplete': 'icon_documents_incomplete.svg ',
    'icon_documents_legal-document': 'icon_documents_legal-document.svg ',
    'icon_documents_message-details': 'icon_documents_message-details.svg ',
    'icon_documents_message-info': 'icon_documents_message-info.svg ',
    'icon_documents_newspaper': 'icon_documents_newspaper.svg ',
    'icon_documents_passport': 'icon_documents_passport.svg ',
    'icon_documents_pdf': 'icon_documents_pdf.svg ',
    'icon_documents_png': 'icon_documents_png.svg ',
    'icon_documents_ppt': 'icon_documents_ppt.svg ',
    'icon_documents_quick-appointment': 'icon_documents_quick-appointment.svg ',
    'icon_documents_refinement': 'icon_documents_refinement.svg ',
    'icon_documents_regulation': 'icon_documents_regulation.svg ',
    'icon_documents_request-appointment': 'icon_documents_request-appointment.svg ',
    'icon_documents_scroll': 'icon_documents_scroll.svg ',
    'icon_documents_share-android': 'icon_documents_share-android.svg ',
    'icon_documents_share-ios': 'icon_documents_share-ios.svg ',
    'icon_documents_sign-up': 'icon_documents_sign-up.svg ',
    'icon_documents_signature-pending': 'icon_documents_signature-pending.svg ',
    'icon_documents_sketch': 'icon_documents_sketch.svg ',
    'icon_documents_sprintplaning': 'icon_documents_sprintplaning.svg ',
    'icon_documents_stack': 'icon_documents_stack.svg ',
    'icon_documents_svg': 'icon_documents_svg.svg ',
    'icon_documents_task-force': 'icon_documents_task-force.svg ',
    'icon_documents_taxonomy-regulation': 'icon_documents_taxonomy-regulation.svg ',
    'icon_documents_terms-conditions': 'icon_documents_terms-conditions.svg ',
    'icon_documents_trash-bin': 'icon_documents_trash-bin.svg ',
    'icon_documents_txt': 'icon_documents_txt.svg ',
    'icon_documents_userstory': 'icon_documents_userstory.svg ',
    'icon_documents_xls': 'icon_documents_xls.svg ',
    'icon_ds_color': 'icon_ds_color.svg ',
    'icon_ds_handle-1': 'icon_ds_handle-1.svg ',
    'icon_ds_handle-2': 'icon_ds_handle-2.svg ',
    'icon_ds_stepper': 'icon_ds_stepper.svg ',
    'icon_hands_associations': 'icon_hands_associations.svg ',
    'icon_hands_credit': 'icon_hands_credit.svg ',
    'icon_hands_deal-handshake': 'icon_hands_deal-handshake.svg ',
    'icon_hands_double-tap': 'icon_hands_double-tap-1.svg ',
    'icon_hands_double-tap-two-fingers': 'icon_hands_double-tap.svg ',
    'icon_hands_down': 'icon_hands_down.svg ',
    'icon_hands_enter-pin': 'icon_hands_enter-pin.svg ',
    'icon_hands_financing': 'icon_hands_financing.svg ',
    'icon_hands_finger': 'icon_hands_finger.svg ',
    'icon_hands_greet': 'icon_hands_greet.svg ',
    'icon_hands_hand-qr': 'icon_hands_hand-qr.svg ',
    'icon_hands_help-us-to-improve-ko': 'icon_hands_help-us-to-improve-ko.svg ',
    'icon_hands_help-us-to-improve': 'icon_hands_help-us-to-improve.svg ',
    'icon_hands_idea': 'icon_hands_idea.svg ',
    'icon_hands_infringements': 'icon_hands_infringements.svg ',
    'icon_hands_international': 'icon_hands_international.svg ',
    'icon_hands_life-mesure': 'icon_hands_life-mesure.svg ',
    'icon_hands_loan': 'icon_hands_loan.svg ',
    'icon_hands_mortgage': 'icon_hands_mortgage.svg ',
    'icon_hands_pinch': 'icon_hands_pinch.svg ',
    'icon_hands_renegotiate': 'icon_hands_renegotiate.svg ',
    'icon_hands_renting-home': 'icon_hands_renting-home.svg ',
    'icon_hands_sign-language': 'icon_hands_sign-language.svg ',
    'icon_hands_single-tap': 'icon_hands_single-tap.svg ',
    'icon_hands_suppliers': 'icon_hands_suppliers.svg ',
    'icon_hands_sustainable': 'icon_hands_sustainable.svg ',
    'icon_hands_swipe-down': 'icon_hands_swipe-down.svg ',
    'icon_hands_swipe-left': 'icon_hands_swipe-left.svg ',
    'icon_hands_swipe-right': 'icon_hands_swipe-right.svg ',
    'icon_hands_swipe-up': 'icon_hands_swipe-up.svg ',
    'icon_hands_tap': 'icon_hands_tap.svg ',
    'icon_hands_technological': 'icon_hands_technological.svg ',
    'icon_hands_time': 'icon_hands_time.svg ',
    'icon_hands_tutorial': 'icon_hands_tutorial.svg ',
    'icon_hands_wash': 'icon_hands_wash.svg ',
    'icon_nature_ant': 'icon_nature_ant.svg ',
    'icon_nature_bug': 'icon_nature_bug.svg ',
    'icon_nature_cloudy': 'icon_nature_cloudy.svg ',
    'icon_nature_commodities': 'icon_nature_commodities.svg ',
    'icon_nature_drop': 'icon_nature_drop.svg ',
    'icon_nature_dynamics': 'icon_nature_dynamics.svg ',
    'icon_nature_fire': 'icon_nature_fire.svg ',
    'icon_nature_fish': 'icon_nature_fish.svg ',
    'icon_nature_flowers': 'icon_nature_flowers.svg ',
    'icon_nature_fog': 'icon_nature_fog.svg ',
    'icon_nature_gale': 'icon_nature_gale.svg ',
    'icon_nature_gold': 'icon_nature_gold.svg ',
    'icon_nature_lake': 'icon_nature_lake.svg ',
    'icon_nature_lightening': 'icon_nature_lightening.svg ',
    'icon_nature_lion': 'icon_nature_lion.svg ',
    'icon_nature_moon-clouds': 'icon_nature_moon-clouds.svg ',
    'icon_nature_moon': 'icon_nature_moon.svg ',
    'icon_nature_outbreaks': 'icon_nature_outbreaks.svg ',
    'icon_nature_owl': 'icon_nature_owl.svg ',
    'icon_nature_plant': 'icon_nature_plant.svg ',
    'icon_nature_rain-shower': 'icon_nature_rain-shower.svg ',
    'icon_nature_rain': 'icon_nature_rain.svg ',
    'icon_nature_sky': 'icon_nature_sky.svg ',
    'icon_nature_snow': 'icon_nature_snow.svg ',
    'icon_nature_snowflake': 'icon_nature_snowflake.svg ',
    'icon_nature_sun-cloud': 'icon_nature_sun-cloud.svg ',
    'icon_nature_sunny': 'icon_nature_sunny.svg ',
    'icon_nature_unicorn': 'icon_nature_unicorn.svg ',
    'icon_objects_accelerator': 'icon_objects_accelerator.svg ',
    'icon_objects_agile': 'icon_objects_agile.svg ',
    'icon_objects_agriculture-tools': 'icon_objects_agriculture-tools.svg ',
    'icon_objects_appliances': 'icon_objects_appliances.svg ',
    'icon_objects_assisted-navigation': 'icon_objects_assisted-navigation.svg ',
    'icon_objects_auction': 'icon_objects_auction.svg ',
    'icon_objects_awards': 'icon_objects_awards.svg ',
    'icon_objects_basket': 'icon_objects_basket.svg ',
    'icon_objects_bath': 'icon_objects_bath.svg ',
    'icon_objects_bathroom-alt': 'icon_objects_bathroom-alt.svg ',
    'icon_objects_bbq': 'icon_objects_bbq.svg ',
    'icon_objects_bed': 'icon_objects_bed.svg ',
    'icon_objects_bell': 'icon_objects_bell.svg ',
    'icon_objects_bodybuilding': 'icon_objects_bodybuilding.svg ',
    'icon_objects_boosts': 'icon_objects_boosts.svg ',
    'icon_objects_box': 'icon_objects_box.svg ',
    'icon_objects_brush': 'icon_objects_brush.svg ',
    'icon_objects_camping-gas': 'icon_objects_camping-gas.svg ',
    'icon_objects_cap': 'icon_objects_cap.svg ',
    'icon_objects_cards': 'icon_objects_cards.svg ',
    'icon_objects_carnivorous-food': 'icon_objects_carnivorous-food.svg ',
    'icon_objects_champions-league': 'icon_objects_champions-league.svg ',
    'icon_objects_chat-bot': 'icon_objects_chat-bot.svg ',
    'icon_objects_children': 'icon_objects_children.svg ',
    'icon_objects_cinema': 'icon_objects_cinema.svg ',
    'icon_objects_clean': 'icon_objects_clean.svg ',
    'icon_objects_clip': 'icon_objects_clip.svg ',
    'icon_objects_commerce': 'icon_objects_commerce.svg ',
    'icon_objects_control': 'icon_objects_control.svg ',
    'icon_objects_death': 'icon_objects_death.svg ',
    'icon_objects_deposits': 'icon_objects_deposits.svg ',
    'icon_objects_diamond': 'icon_objects_diamond.svg ',
    'icon_objects_dice': 'icon_objects_dice.svg ',
    'icon_objects_dirty': 'icon_objects_dirty.svg ',
    'icon_objects_doctor': 'icon_objects_doctor.svg ',
    'icon_objects_domestic-service': 'icon_objects_domestic-service.svg ',
    'icon_objects_entertainment-leisure': 'icon_objects_entertainment-leisure.svg ',
    'icon_objects_fashion': 'icon_objects_fashion.svg ',
    'icon_objects_fishermen': 'icon_objects_fishermen.svg ',
    'icon_objects_fragile': 'icon_objects_fragile.svg ',
    'icon_objects_free-wi-fi': 'icon_objects_free-wi-fi.svg ',
    'icon_objects_furniture': 'icon_objects_furniture.svg ',
    'icon_objects_ghost': 'icon_objects_ghost.svg ',
    'icon_objects_gift': 'icon_objects_gift.svg ',
    'icon_objects_golf': 'icon_objects_golf.svg ',
    'icon_objects_hair-stylist': 'icon_objects_hair-stylist.svg ',
    'icon_objects_hammer': 'icon_objects_hammer.svg ',
    'icon_objects_health-check': 'icon_objects_health-check.svg ',
    'icon_objects_health-insurance': 'icon_objects_health-insurance.svg ',
    'icon_objects_hourglass-end': 'icon_objects_hourglass-end.svg ',
    'icon_objects_hourglass-start': 'icon_objects_hourglass-start.svg ',
    'icon_objects_idea': 'icon_objects_idea.svg ',
    'icon_objects_insurance': 'icon_objects_insurance.svg ',
    'icon_objects_key': 'icon_objects_key.svg ',
    'icon_objects_king': 'icon_objects_king.svg ',
    'icon_objects_lamp': 'icon_objects_lamp.svg ',
    'icon_objects_life-saver': 'icon_objects_life-saver.svg ',
    'icon_objects_liquidation': 'icon_objects_liquidation.svg ',
    'icon_objects_magnet': 'icon_objects_magnet.svg ',
    'icon_objects_maintenance': 'icon_objects_maintenance.svg ',
    'icon_objects_maternity': 'icon_objects_maternity.svg ',
    'icon_objects_medal': 'icon_objects_medal.svg ',
    'icon_objects_microphone': 'icon_objects_microphone.svg ',
    'icon_objects_miscellaneous': 'icon_objects_miscellaneous.svg ',
    'icon_objects_motor-sports': 'icon_objects_motor-sports.svg ',
    'icon_objects_museum': 'icon_objects_museum.svg ',
    'icon_objects_music': 'icon_objects_music.svg ',
    'icon_objects_nail': 'icon_objects_nail.svg ',
    'icon_objects_nut': 'icon_objects_nut.svg ',
    'icon_objects_nutritional': 'icon_objects_nutritional.svg ',
    'icon_objects_office-workers': 'icon_objects_office-workers.svg ',
    'icon_objects_operability-level': 'icon_objects_operability-level.svg ',
    'icon_objects_orthdontics': 'icon_objects_orthdontics.svg ',
    'icon_objects_pacman': 'icon_objects_pacman.svg ',
    'icon_objects_party': 'icon_objects_party.svg ',
    'icon_objects_pin': 'icon_objects_pin.svg ',
    'icon_objects_portfolio': 'icon_objects_portfolio.svg ',
    'icon_objects_product-delivery': 'icon_objects_product-delivery.svg ',
    'icon_objects_puzzle': 'icon_objects_puzzle.svg ',
    'icon_objects_rackets-sports': 'icon_objects_rackets-sports.svg ',
    'icon_objects_radar': 'icon_objects_radar.svg ',
    'icon_objects_reform': 'icon_objects_reform.svg ',
    'icon_objects_reforms-decorations': 'icon_objects_reforms-decorations.svg ',
    'icon_objects_reports': 'icon_objects_reports.svg ',
    'icon_objects_restaurant': 'icon_objects_restaurant.svg ',
    'icon_objects_retail': 'icon_objects_retail.svg ',
    'icon_objects_retrospective': 'icon_objects_retrospective.svg ',
    'icon_objects_ribbon': 'icon_objects_ribbon.svg ',
    'icon_objects_scales': 'icon_objects_scales.svg ',
    'icon_objects_screwdriver': 'icon_objects_screwdriver.svg ',
    'icon_objects_scrum': 'icon_objects_scrum.svg ',
    'icon_objects_seafood': 'icon_objects_seafood.svg ',
    'icon_objects_shower': 'icon_objects_shower.svg ',
    'icon_objects_soap': 'icon_objects_soap.svg ',
    'icon_objects_soccer': 'icon_objects_soccer.svg ',
    'icon_objects_spa': 'icon_objects_spa.svg ',
    'icon_objects_sports-risk': 'icon_objects_sports-risk.svg ',
    'icon_objects_sports': 'icon_objects_sports.svg ',
    'icon_objects_sprint-review': 'icon_objects_sprint-review.svg ',
    'icon_objects_student': 'icon_objects_student.svg ',
    'icon_objects_supermarket': 'icon_objects_supermarket.svg ',
    'icon_objects_tailor': 'icon_objects_tailor.svg ',
    'icon_objects_tampon': 'icon_objects_tampon.svg ',
    'icon_objects_taxes': 'icon_objects_taxes.svg ',
    'icon_objects_terminal-code': 'icon_objects_terminal-code.svg ',
    'icon_objects_ticket-movie': 'icon_objects_ticket-movie.svg ',
    'icon_objects_time': 'icon_objects_time.svg ',
    'icon_objects_tools': 'icon_objects_tools.svg ',
    'icon_objects_torch': 'icon_objects_torch.svg ',
    'icon_objects_training': 'icon_objects_training.svg ',
    'icon_objects_trophy': 'icon_objects_trophy.svg ',
    'icon_objects_university': 'icon_objects_university.svg ',
    'icon_objects_vegetarian-food': 'icon_objects_vegetarian-food.svg ',
    'icon_objects_velocity': 'icon_objects_velocity.svg ',
    'icon_objects_veterinary': 'icon_objects_veterinary.svg ',
    'icon_objects_whistle': 'icon_objects_whistle.svg ',
    'icon_objects_yoga': 'icon_objects_yoga.svg ',
    'icon_operations_automatic-savings': 'icon_operations_automatic-savings.svg ',
    'icon_operations_booklet-atm-enter': 'icon_operations_booklet-atm-enter.svg ',
    'icon_operations_booklet-atm-withdraw': 'icon_operations_booklet-atm-withdraw.svg ',
    'icon_operations_cancel-check': 'icon_operations_cancel-check.svg ',
    'icon_operations_cancel-checkbook': 'icon_operations_cancel-checkbook.svg ',
    'icon_operations_cancel-next-receipt': 'icon_operations_cancel-next-receipt.svg ',
    'icon_operations_capitalization': 'icon_operations_capitalization.svg ',
    'icon_operations_change-associated-account': 'icon_operations_change-associated-account.svg ',
    'icon_operations_check-previous-transfers': 'icon_operations_check-previous-transfers.svg ',
    'icon_operations_check-upcoming-transfers': 'icon_operations_check-upcoming-transfers.svg ',
    'icon_operations_check': 'icon_operations_check.svg ',
    'icon_operations_checkbook': 'icon_operations_checkbook.svg ',
    'icon_operations_circular-economy': 'icon_operations_circular-economy.svg ',
    'icon_operations_debt': 'icon_operations_debt.svg ',
    'icon_operations_deferred-transfer': 'icon_operations_deferred-transfer.svg ',
    'icon_operations_delete-account': 'icon_operations_delete-account.svg ',
    'icon_operations_deposit-check': 'icon_operations_deposit-check.svg ',
    'icon_operations_duplicated-receipt': 'icon_operations_duplicated-receipt.svg ',
    'icon_operations_early-cancellation': 'icon_operations_early-cancellation.svg ',
    'icon_operations_early-repayment': 'icon_operations_early-repayment.svg ',
    'icon_operations_edit-transfer': 'icon_operations_edit-transfer.svg ',
    'icon_operations_enter-money-atm': 'icon_operations_enter-money-atm.svg ',
    'icon_operations_equator-principles': 'icon_operations_equator-principles.svg ',
    'icon_operations_esg-funds': 'icon_operations_esg-funds.svg ',
    'icon_operations_factoring': 'icon_operations_factoring.svg ',
    'icon_operations_financial-indicator': 'icon_operations_financial-indicator.svg ',
    'icon_operations_financial-manager': 'icon_operations_financial-manager.svg ',
    'icon_operations_fixed-expenses': 'icon_operations_fixed-expenses.svg ',
    'icon_operations_funds-transfer': 'icon_operations_funds-transfer.svg ',
    'icon_operations_green-bond': 'icon_operations_green-bond.svg ',
    'icon_operations_income-tax': 'icon_operations_income-tax.svg ',
    'icon_operations_invest': 'icon_operations_invest.svg ',
    'icon_operations_investment-fund': 'icon_operations_investment-fund.svg ',
    'icon_operations_linear-economy': 'icon_operations_linear-economy.svg ',
    'icon_operations_new-account': 'icon_operations_new-account.svg ',
    'icon_operations_no-transactions': 'icon_operations_no-transactions.svg ',
    'icon_operations_online-banking': 'icon_operations_online-banking.svg ',
    'icon_operations_online-trading': 'icon_operations_online-trading.svg ',
    'icon_operations_other-expenses': 'icon_operations_other-expenses.svg ',
    'icon_operations_overdraft': 'icon_operations_overdraft.svg ',
    'icon_operations_paris-agreement': 'icon_operations_paris-agreement.svg ',
    'icon_operations_periodic-transfer': 'icon_operations_periodic-transfer.svg ',
    'icon_operations_portfolio-alignment': 'icon_operations_portfolio-alignment.svg ',
    'icon_operations_portfolio-of-values': 'icon_operations_portfolio-of-values.svg ',
    'icon_operations_previous-transfers': 'icon_operations_previous-transfers.svg ',
    'icon_operations_receipt-bills': 'icon_operations_receipt-bills.svg ',
    'icon_operations_receipt-management': 'icon_operations_receipt-management.svg ',
    'icon_operations_receive': 'icon_operations_receive.svg ',
    'icon_operations_received': 'icon_operations_received.svg ',
    'icon_operations_rejected-receipts': 'icon_operations_rejected-receipts.svg ',
    'icon_operations_renegotiation': 'icon_operations_renegotiation.svg ',
    'icon_operations_rescue-investment': 'icon_operations_rescue-investment.svg ',
    'icon_operations_responsible-investment': 'icon_operations_responsible-investment.svg ',
    'icon_operations_responsible-ranking': 'icon_operations_responsible-ranking.svg ',
    'icon_operations_return-receipt': 'icon_operations_return-receipt.svg ',
    'icon_operations_saving-investment': 'icon_operations_saving-investment.svg ',
    'icon_operations_savings': 'icon_operations_savings.svg ',
    'icon_operations_sepa-transfers': 'icon_operations_sepa-transfers.svg ',
    'icon_operations_solidarity-rounding': 'icon_operations_solidarity-rounding.svg ',
    'icon_operations_transfer-money': 'icon_operations_transfer-money.svg ',
    'icon_operations_transfer': 'icon_operations_transfer.svg ',
    'icon_operations_value-down': 'icon_operations_value-down.svg ',
    'icon_operations_value-increase': 'icon_operations_value-increase.svg ',
    'icon_operations_value': 'icon_operations_value.svg ',
    'icon_operations_wallet': 'icon_operations_wallet.svg ',
    'icon_operations_withdraw-money-atm': 'icon_operations_withdraw-money-atm.svg ',
    'icon_operations_withdraw-receipt-atm': 'icon_operations_withdraw-receipt-atm.svg ',
    'icon_people_academy': 'icon_people_academy.svg ',
    'icon_people_accessibility': 'icon_people_accessibility.svg ',
    'icon_people_account-people': 'icon_people_account-people.svg ',
    'icon_people_account-user': 'icon_people_account-user.svg ',
    'icon_people_bathroom': 'icon_people_bathroom.svg ',
    'icon_people_become-new-client': 'icon_people_become-new-client.svg ',
    'icon_people_benefitiary': 'icon_people_benefitiary.svg ',
    'icon_people_change-beneficiary': 'icon_people_change-beneficiary.svg ',
    'icon_people_circle-account-user-add': 'icon_people_circle-account-user-add.svg ',
    'icon_people_circle-account-user': 'icon_people_circle-account-user.svg ',
    'icon_people_clients': 'icon_people_clients.svg ',
    'icon_people_disable-user': 'icon_people_disable-user.svg ',
    'icon_people_emoji-angry': 'icon_people_emoji-angry.svg ',
    'icon_people_emoji-happy': 'icon_people_emoji-happy.svg ',
    'icon_people_emoji-kiss': 'icon_people_emoji-kiss.svg ',
    'icon_people_emoji-neutral': 'icon_people_emoji-neutral.svg ',
    'icon_people_emoji-reised-eyebrow': 'icon_people_emoji-reised-eyebrow.svg ',
    'icon_people_emoji-sad': 'icon_people_emoji-sad.svg ',
    'icon_people_employees': 'icon_people_employees.svg ',
    'icon_people_family': 'icon_people_family.svg ',
    'icon_people_fatca': 'icon_people_fatca.svg ',
    'icon_people_investor-profile': 'icon_people_investor-profile.svg ',
    'icon_people_man-face-mask': 'icon_people_man-face-mask.svg ',
    'icon_people_management-health': 'icon_people_management-health.svg ',
    'icon_people_management': 'icon_people_management.svg ',
    'icon_people_marternity': 'icon_people_marternity.svg ',
    'icon_people_personal-manager': 'icon_people_personal-manager.svg ',
    'icon_people_personal-protection': 'icon_people_personal-protection.svg ',
    'icon_people_reactivate-user': 'icon_people_reactivate-user.svg ',
    'icon_people_refer-a-friend': 'icon_people_refer-a-friend.svg ',
    'icon_people_remove-adding-profile': 'icon_people_remove-adding-profile.svg ',
    'icon_people_remove-profile-1': 'icon_people_remove-profile-1.svg ',
    'icon_people_remove-profile': 'icon_people_remove-profile.svg ',
    'icon_people_retirement-plan-elderly': 'icon_people_retirement-plan-elderly.svg ',
    'icon_people_scrum-master': 'icon_people_scrum-master.svg ',
    'icon_people_shareholders': 'icon_people_shareholders.svg ',
    'icon_people_team-interaction': 'icon_people_team-interaction.svg ',
    'icon_people_team-managament': 'icon_people_team-managament.svg ',
    'icon_people_team-together': 'icon_people_team-together.svg ',
    'icon_people_wheelchair': 'icon_people_wheelchair.svg ',
    'icon_people_woman': 'icon_people_woman.svg ',
    'icon_places_beach': 'icon_places_beach.svg ',
    'icon_places_building': 'icon_places_building.svg ',
    'icon_places_business-alert': 'icon_places_business-alert.svg ',
    'icon_places_business-store': 'icon_places_business-store.svg ',
    'icon_places_business-support': 'icon_places_business-support.svg ',
    'icon_places_city': 'icon_places_city.svg ',
    'icon_places_company-radar': 'icon_places_company-radar.svg ',
    'icon_places_countryside': 'icon_places_countryside.svg ',
    'icon_places_dealership': 'icon_places_dealership.svg ',
    'icon_places_factory-net-zero-carbon-emissions': 'icon_places_factory-net-zero-carbon-emissions.svg ',
    'icon_places_factory': 'icon_places_factory.svg ',
    'icon_places_foreign-trade': 'icon_places_foreign-trade.svg ',
    'icon_places_franchise': 'icon_places_franchise.svg ',
    'icon_places_home': 'icon_places_home.svg ',
    'icon_places_hospital': 'icon_places_hospital.svg ',
    'icon_places_housing': 'icon_places_housing.svg ',
    'icon_places_inspection': 'icon_places_inspection.svg ',
    'icon_places_international': 'icon_places_international.svg ',
    'icon_places_lake': 'icon_places_lake.svg ',
    'icon_places_lighthouse': 'icon_places_lighthouse.svg ',
    'icon_places_local-commerce': 'icon_places_local-commerce.svg ',
    'icon_places_location-active': 'icon_places_location-active.svg ',
    'icon_places_location-inactive': 'icon_places_location-inactive.svg ',
    'icon_places_location': 'icon_places_location.svg ',
    'icon_places_mountains': 'icon_places_mountains.svg ',
    'icon_places_place': 'icon_places_place.svg ',
    'icon_places_realestatecredit': 'icon_places_realestatecredit.svg ',
    'icon_places_realestatevalue': 'icon_places_realestatevalue.svg ',
    'icon_products_deposits': 'icon_products_deposits.svg ',
    'icon_products_financial-aggregator': 'icon_products_financial-aggregator.svg ',
    'icon_security_atm-code': 'icon_security_atm-code.svg ',
    'icon_security_block': 'icon_security_block.svg ',
    'icon_security_civil-liability': 'icon_security_civil-liability.svg ',
    'icon_security_close': 'icon_security_close.svg ',
    'icon_security_configuration': 'icon_security_configuration.svg ',
    'icon_security_cookies-policy': 'icon_security_cookies-policy.svg ',
    'icon_security_coordinates-card': 'icon_security_coordinates-card.svg ',
    'icon_security_email': 'icon_security_email.svg ',
    'icon_security_face-id': 'icon_security_face-id.svg ',
    'icon_security_fraud': 'icon_security_fraud.svg ',
    'icon_security_get-pin-number': 'icon_security_get-pin-number.svg ',
    'icon_security_get-your-key': 'icon_security_get-your-key.svg ',
    'icon_security_locked-android': 'icon_security_locked-android.svg ',
    'icon_security_locked-chrome': 'icon_security_locked-chrome.svg ',
    'icon_security_locked-ios': 'icon_security_locked-ios.svg ',
    'icon_security_lockout': 'icon_security_lockout.svg ',
    'icon_security_mobile': 'icon_security_mobile.svg ',
    'icon_security_password-typing': 'icon_security_password-typing.svg ',
    'icon_security_payment': 'icon_security_payment.svg ',
    'icon_security_phishing': 'icon_security_phishing.svg ',
    'icon_security_protected-home': 'icon_security_protected-home.svg ',
    'icon_security_recover-access-keys': 'icon_security_recover-access-keys.svg ',
    'icon_security_security-advice': 'icon_security_security-advice.svg ',
    'icon_security_security-error': 'icon_security_security-error.svg ',
    'icon_security_security-open': 'icon_security_security-open.svg ',
    'icon_security_security': 'icon_security_security.svg ',
    'icon_security_touch-id': 'icon_security_touch-id.svg ',
    'icon_security_unlinked': 'icon_security_unlinked.svg ',
    'icon_security_unlocked-android': 'icon_security_unlocked-android.svg ',
    'icon_security_unlocked-ios': 'icon_security_unlocked-ios.svg ',
    'icon_security_verified': 'icon_security_verified.svg ',
    'icon_social_apple-outline': 'icon_social_apple-outline.svg ',
    'icon_social_blink': 'icon_social_blink.svg ',
    'icon_social_facebook-outline': 'icon_social_facebook-outline.svg ',
    'icon_social_facebook': 'icon_social_facebook.svg ',
    'icon_social_google-play-outline': 'icon_social_google-play-outline.svg ',
    'icon_social_instagram-outline': 'icon_social_instagram-outline.svg ',
    'icon_social_instagram': 'icon_social_instagram.svg ',
    'icon_social_linkedin-outline': 'icon_social_linkedin-outline.svg ',
    'icon_social_linkedin': 'icon_social_linkedin.svg ',
    'icon_social_podcast-outline': 'icon_social_podcast-outline.svg ',
    'icon_social_tiktok-outline': 'icon_social_tiktok-outline.svg ',
    'icon_social_tiktok': 'icon_social_tiktok.svg ',
    'icon_social_twitter-outline': 'icon_social_twitter-outline.svg ',
    'icon_social_twitter': 'icon_social_twitter.svg ',
    'icon_social_whatsapp-outline': 'icon_social_whatsapp-outline.svg ',
    'icon_social_whatsapp': 'icon_social_whatsapp.svg ',
    'icon_social_youtube-outline': 'icon_social_youtube-outline.svg ',
    'icon_social_youtube': 'icon_social_youtube.svg ',
    'icon_social_zelle-glyph': 'icon_social_zelle-glyph.svg ',
    'icon_social_zelle-outline': 'icon_social_zelle-outline.svg ',
    'icon_social_zelle': 'icon_social_zelle.svg ',
    'icon_symbols_add-in-a-circle': 'icon_symbols_add-in-a-circle.svg ',
    'icon_symbols_add-photo': 'icon_symbols_add-photo.svg ',
    'icon_symbols_add-thick': 'icon_symbols_add-thick.svg ',
    'icon_symbols_add': 'icon_symbols_add.svg ',
    'icon_symbols_aesthetics': 'icon_symbols_aesthetics.svg ',
    'icon_symbols_alert': 'icon_symbols_alert.svg ',
    'icon_symbols_alphabetical-order': 'icon_symbols_alphabetical-order.svg ',
    'icon_symbols_american': 'icon_symbols_american.svg ',
    'icon_symbols_audio-off': 'icon_symbols_audio-off.svg ',
    'icon_symbols_audio-on': 'icon_symbols_audio-on.svg ',
    'icon_symbols_authentication': 'icon_symbols_authentication.svg ',
    'icon_symbols_backspace-fill': 'icon_symbols_backspace-fill.svg ',
    'icon_symbols_backspace': 'icon_symbols_backspace.svg ',
    'icon_symbols_backward-button': 'icon_symbols_backward-button.svg ',
    'icon_symbols_barcode': 'icon_symbols_barcode.svg ',
    'icon_symbols_bill-recycler': 'icon_symbols_bill-recycler.svg ',
    'icon_symbols_block-in-a-circle': 'icon_symbols_block-in-a-circle.svg ',
    'icon_symbols_boxes': 'icon_symbols_boxes.svg ',
    'icon_symbols_burger-menu-asymmetrical': 'icon_symbols_burger-menu-asymmetrical.svg ',
    'icon_symbols_burger-menu-thick': 'icon_symbols_burger-menu-thick.svg ',
    'icon_symbols_burger-menu': 'icon_symbols_burger-menu.svg ',
    'icon_symbols_camera': 'icon_symbols_camera.svg ',
    'icon_symbols_center-position': 'icon_symbols_center-position.svg ',
    'icon_symbols_check-asigment': 'icon_symbols_check-asigment.svg ',
    'icon_symbols_check-scanner': 'icon_symbols_check-scanner.svg ',
    'icon_symbols_checkmark-2': 'icon_symbols_checkmark-2.svg ',
    'icon_symbols_checkmark-in-a-circle': 'icon_symbols_checkmark-in-a-circle.svg ',
    'icon_symbols_checkmark-select': 'icon_symbols_checkmark-select.svg ',
    'icon_symbols_checkmark-thick': 'icon_symbols_checkmark-thick.svg ',
    'icon_symbols_checkmark': 'icon_symbols_checkmark.svg ',
    'icon_symbols_circle-fit': 'icon_symbols_circle-fit.svg ',
    'icon_symbols_circle': 'icon_symbols_circle.svg ',
    'icon_symbols_climate-change': 'icon_symbols_climate-change.svg ',
    'icon_symbols_clock-out': 'icon_symbols_clock-out.svg ',
    'icon_symbols_clock-restart': 'icon_symbols_clock-restart.svg ',
    'icon_symbols_close-thick': 'icon_symbols_close-thick.svg ',
    'icon_symbols_close': 'icon_symbols_close.svg ',
    'icon_symbols_collapse-keyboard': 'icon_symbols_collapse-keyboard.svg ',
    'icon_symbols_correct': 'icon_symbols_correct.svg ',
    'icon_symbols_daily': 'icon_symbols_daily.svg ',
    'icon_symbols_day-time-change': 'icon_symbols_day-time-change.svg ',
    'icon_symbols_discount': 'icon_symbols_discount.svg ',
    'icon_symbols_dot-fill': 'icon_symbols_dot-fill.svg ',
    'icon_symbols_dots-horizontal': 'icon_symbols_dots-horizontal.svg ',
    'icon_symbols_dots-vertical': 'icon_symbols_dots-vertical.svg ',
    'icon_symbols_dragndrop': 'icon_symbols_dragndrop.svg ',
    'icon_symbols_ecb': 'icon_symbols_ecb.svg ',
    'icon_symbols_edit': 'icon_symbols_edit.svg ',
    'icon_symbols_error': 'icon_symbols_error.svg ',
    'icon_symbols_expand-keyboard': 'icon_symbols_expand-keyboard.svg ',
    'icon_symbols_face-id-apple': 'icon_symbols_face-id-apple.svg ',
    'icon_symbols_face-id': 'icon_symbols_face-id.svg ',
    'icon_symbols_featured': 'icon_symbols_featured.svg ',
    'icon_symbols_filter-desactivate': 'icon_symbols_filter-desactivate.svg ',
    'icon_symbols_filter': 'icon_symbols_filter.svg ',
    'icon_symbols_fit-dot-fill': 'icon_symbols_fit-dot-fill.svg ',
    'icon_symbols_fit-square-fill': 'icon_symbols_fit-square-fill.svg ',
    'icon_symbols_font-adjust': 'icon_symbols_font-adjust.svg ',
    'icon_symbols_font-size-decrease': 'icon_symbols_font-size-decrease.svg ',
    'icon_symbols_font-size-increase': 'icon_symbols_font-size-increase.svg ',
    'icon_symbols_forward-button': 'icon_symbols_forward-button.svg ',
    'icon_symbols_heart': 'icon_symbols_heart.svg ',
    'icon_symbols_help-in-a-circle': 'icon_symbols_help-in-a-circle.svg ',
    'icon_symbols_hi-contrast': 'icon_symbols_hi-contrast.svg ',
    'icon_symbols_highlighted-services': 'icon_symbols_highlighted-services.svg ',
    'icon_symbols_history': 'icon_symbols_history.svg ',
    'icon_symbols_information-in-a-circle': 'icon_symbols_information-in-a-circle.svg ',
    'icon_symbols_language': 'icon_symbols_language.svg ',
    'icon_symbols_link': 'icon_symbols_link.svg ',
    'icon_symbols_list': 'icon_symbols_list.svg ',
    'icon_symbols_mic-off': 'icon_symbols_mic-off.svg ',
    'icon_symbols_mic-on': 'icon_symbols_mic-on.svg ',
    'icon_symbols_mic': 'icon_symbols_mic.svg ',
    'icon_symbols_minimise-thick': 'icon_symbols_minimise-thick.svg ',
    'icon_symbols_minimise': 'icon_symbols_minimise.svg ',
    'icon_symbols_minus-in-a-circle': 'icon_symbols_minus-in-a-circle.svg ',
    'icon_symbols_more-in-a-circle': 'icon_symbols_more-in-a-circle.svg ',
    'icon_symbols_non-supported-browser': 'icon_symbols_non-supported-browser.svg ',
    'icon_symbols_now': 'icon_symbols_now.svg ',
    'icon_symbols_offer-discount': 'icon_symbols_offer-discount.svg ',
    'icon_symbols_others': 'icon_symbols_others.svg ',
    'icon_symbols_pause-button': 'icon_symbols_pause-button.svg ',
    'icon_symbols_percent': 'icon_symbols_percent.svg ',
    'icon_symbols_periodical-input': 'icon_symbols_periodical-input.svg ',
    'icon_symbols_placeholder': 'icon_symbols_placeholder.svg ',
    'icon_symbols_play-button': 'icon_symbols_play-button.svg ',
    'icon_symbols_plusless': 'icon_symbols_plusless.svg ',
    'icon_symbols_popup': 'icon_symbols_popup.svg ',
    'icon_symbols_position': 'icon_symbols_position.svg ',
    'icon_symbols_power': 'icon_symbols_power.svg ',
    'icon_symbols_print': 'icon_symbols_print.svg ',
    'icon_symbols_qr-advanced': 'icon_symbols_qr-advanced.svg ',
    'icon_symbols_qr-code': 'icon_symbols_qr-code.svg ',
    'icon_symbols_queries': 'icon_symbols_queries.svg ',
    'icon_symbols_rec-button': 'icon_symbols_rec-button.svg ',
    'icon_symbols_santander-plus': 'icon_symbols_santander-plus.svg ',
    'icon_symbols_scanner-machine': 'icon_symbols_scanner-machine.svg ',
    'icon_symbols_scanner': 'icon_symbols_scanner.svg ',
    'icon_symbols_search': 'icon_symbols_search.svg ',
    'icon_symbols_selfie': 'icon_symbols_selfie.svg ',
    'icon_symbols_settings': 'icon_symbols_settings.svg ',
    'icon_symbols_star-filled': 'icon_symbols_star-filled.svg ',
    'icon_symbols_star': 'icon_symbols_star.svg ',
    'icon_symbols_stop-button': 'icon_symbols_stop-button.svg ',
    'icon_symbols_subscription-model': 'icon_symbols_subscription-model.svg ',
    'icon_symbols_subscription': 'icon_symbols_subscription.svg ',
    'icon_symbols_subtract-thick': 'icon_symbols_subtract-thick.svg ',
    'icon_symbols_subtract': 'icon_symbols_subtract.svg ',
    'icon_symbols_success': 'icon_symbols_success.svg ',
    'icon_symbols_system-error': 'icon_symbols_system-error.svg ',
    'icon_symbols_time-hours': 'icon_symbols_time-hours.svg ',
    'icon_symbols_timeout': 'icon_symbols_timeout.svg ',
    'icon_symbols_token-migration': 'icon_symbols_token-migration.svg ',
    'icon_symbols_token': 'icon_symbols_token.svg ',
    'icon_symbols_urgent': 'icon_symbols_urgent.svg ',
    'icon_symbols_utilities-services': 'icon_symbols_utilities-services.svg ',
    'icon_symbols_visibility-off': 'icon_symbols_visibility-off.svg ',
    'icon_symbols_visibility-on': 'icon_symbols_visibility-on.svg ',
    'icon_symbols_warning-in-a-circle': 'icon_symbols_warning-in-a-circle.svg ',
    'icon_symbols_warning': 'icon_symbols_warning.svg ',
    'icon_symbols_webmotors': 'icon_symbols_webmotors.svg ',
    'icon_symbols_window-success': 'icon_symbols_window-success.svg ',
    'icon_symbols_zoom-in': 'icon_symbols_zoom-in.svg ',
    'icon_symbols_zoom-out': 'icon_symbols_zoom-out.svg ',
    'icon_technology_antenna': 'icon_technology_antenna.svg ',
    'icon_technology_at': 'icon_technology_at.svg ',
    'icon_technology_atom': 'icon_technology_atom.svg ',
    'icon_technology_chemistry': 'icon_technology_chemistry.svg ',
    'icon_technology_circuit': 'icon_technology_circuit.svg ',
    'icon_technology_cloud': 'icon_technology_cloud.svg ',
    'icon_technology_code-window': 'icon_technology_code-window.svg ',
    'icon_technology_contacless': 'icon_technology_contacless.svg ',
    'icon_technology_dna': 'icon_technology_dna.svg ',
    'icon_technology_download-from-cloud': 'icon_technology_download-from-cloud.svg ',
    'icon_technology_energy': 'icon_technology_energy.svg ',
    'icon_technology_eolic-energy': 'icon_technology_eolic-energy.svg ',
    'icon_technology_firewall': 'icon_technology_firewall.svg ',
    'icon_technology_free-wi-fi': 'icon_technology_free-wi-fi.svg ',
    'icon_technology_petrol-tower': 'icon_technology_petrol-tower.svg ',
    'icon_technology_pill': 'icon_technology_pill.svg ',
    'icon_technology_plug': 'icon_technology_plug.svg ',
    'icon_technology_sim-chip-insert': 'icon_technology_sim-chip-insert.svg ',
    'icon_technology_sim-chip': 'icon_technology_sim-chip.svg ',
    'icon_technology_solar-energy': 'icon_technology_solar-energy.svg ',
    'icon_technology_sound-wave': 'icon_technology_sound-wave.svg ',
    'icon_technology_sustainable-development-goals': 'icon_technology_sustainable-development-goals.svg ',
    'icon_technology_upload-to-cloud': 'icon_technology_upload-to-cloud.svg ',
    'icon_technology_wi-fi': 'icon_technology_wi-fi.svg ',
    'icon_transport_agribusiness': 'icon_transport_agribusiness.svg ',
    'icon_transport_ambulance': 'icon_transport_ambulance.svg ',
    'icon_transport_bike': 'icon_transport_bike.svg ',
    'icon_transport_boat': 'icon_transport_boat.svg ',
    'icon_transport_delivery': 'icon_transport_delivery.svg ',
    'icon_transport_electric-bike': 'icon_transport_electric-bike.svg ',
    'icon_transport_electric-car': 'icon_transport_electric-car.svg ',
    'icon_transport_entrepreneurship': 'icon_transport_entrepreneurship.svg ',
    'icon_transport_gas-station': 'icon_transport_gas-station.svg ',
    'icon_transport_highway': 'icon_transport_highway.svg ',
    'icon_transport_luggage': 'icon_transport_luggage.svg ',
    'icon_transport_motorbike': 'icon_transport_motorbike.svg ',
    'icon_transport_multicars': 'icon_transport_multicars.svg ',
    'icon_transport_plane-1': 'icon_transport_plane-1.svg ',
    'icon_transport_airplane': 'icon_transport_airplane.svg ',
    'icon_transport_public-transport': 'icon_transport_public-transport.svg ',
    'icon_transport_renting-car': 'icon_transport_renting-car.svg ',
    'icon_transport_sinister-car': 'icon_transport_sinister-car.svg ',
    'icon_transport_subway': 'icon_transport_subway.svg ',
    'icon_transport_tow-truck': 'icon_transport_tow-truck.svg ',
    'icon_transport_train': 'icon_transport_train.svg ',
    'icon_transport_truck': 'icon_transport_truck.svg',
    'flag_rounded_africa_algeria': 'flag_rounded_africa_algeria.svg ',
    'flag_rounded_africa_angola': 'flag_rounded_africa_angola.svg ',
    'flag_rounded_africa_benin': 'flag_rounded_africa_benin.svg ',
    'flag_rounded_africa_botswana': 'flag_rounded_africa_botswana.svg ',
    'flag_rounded_africa_burkina-faso': 'flag_rounded_africa_burkina-faso.svg ',
    'flag_rounded_africa_burundi': 'flag_rounded_africa_burundi.svg ',
    'flag_rounded_africa_cameroon': 'flag_rounded_africa_cameroon.svg ',
    'flag_rounded_africa_cape-verde': 'flag_rounded_africa_cape-verde.svg ',
    'flag_rounded_africa_central-african-republic': 'flag_rounded_africa_central-african-republic.svg ',
    'flag_rounded_africa_chad': 'flag_rounded_africa_chad.svg ',
    'flag_rounded_africa_comoros': 'flag_rounded_africa_comoros.svg ',
    'flag_rounded_africa_djibouti': 'flag_rounded_africa_djibouti.svg ',
    'flag_rounded_africa_egypt': 'flag_rounded_africa_egypt.svg ',
    'flag_rounded_africa_equatorial-guinea': 'flag_rounded_africa_equatorial-guinea.svg ',
    'flag_rounded_africa_eritrea': 'flag_rounded_africa_eritrea.svg ',
    'flag_rounded_africa_ethiopia': 'flag_rounded_africa_ethiopia.svg ',
    'flag_rounded_africa_gabon': 'flag_rounded_africa_gabon.svg ',
    'flag_rounded_africa_gambia': 'flag_rounded_africa_gambia.svg ',
    'flag_rounded_africa_ghana': 'flag_rounded_africa_ghana.svg ',
    'flag_rounded_africa_guinea-bissau': 'flag_rounded_africa_guinea-bissau.svg ',
    'flag_rounded_africa_guinea': 'flag_rounded_africa_guinea.svg ',
    'flag_rounded_africa_ivory-coast': 'flag_rounded_africa_ivory-coast.svg ',
    'flag_rounded_africa_kenya': 'flag_rounded_africa_kenya.svg ',
    'flag_rounded_africa_lesotho': 'flag_rounded_africa_lesotho.svg ',
    'flag_rounded_africa_liberia': 'flag_rounded_africa_liberia.svg ',
    'flag_rounded_africa_libya': 'flag_rounded_africa_libya.svg ',
    'flag_rounded_africa_madagascar': 'flag_rounded_africa_madagascar.svg ',
    'flag_rounded_africa_malawi': 'flag_rounded_africa_malawi.svg ',
    'flag_rounded_africa_mali': 'flag_rounded_africa_mali.svg ',
    'flag_rounded_africa_mauritania': 'flag_rounded_africa_mauritania.svg ',
    'flag_rounded_africa_mauritius': 'flag_rounded_africa_mauritius.svg ',
    'flag_rounded_africa_morocco': 'flag_rounded_africa_morocco.svg ',
    'flag_rounded_africa_mozambique': 'flag_rounded_africa_mozambique.svg ',
    'flag_rounded_africa_namibia': 'flag_rounded_africa_namibia.svg ',
    'flag_rounded_africa_niger': 'flag_rounded_africa_niger.svg ',
    'flag_rounded_africa_nigeria': 'flag_rounded_africa_nigeria.svg ',
    'flag_rounded_africa_republic-of-the-congo': 'flag_rounded_africa_republic-of-the-congo.svg ',
    'flag_rounded_africa_rwanda': 'flag_rounded_africa_rwanda.svg ',
    'flag_rounded_africa_sao-tome-and-principe': 'flag_rounded_africa_sao-tome-and-principe.svg ',
    'flag_rounded_africa_senegal': 'flag_rounded_africa_senegal.svg ',
    'flag_rounded_africa_seychelles': 'flag_rounded_africa_seychelles.svg ',
    'flag_rounded_africa_sierra-leone': 'flag_rounded_africa_sierra-leone.svg ',
    'flag_rounded_africa_somalia': 'flag_rounded_africa_somalia.svg ',
    'flag_rounded_africa_somaliland': 'flag_rounded_africa_somaliland.svg ',
    'flag_rounded_africa_south-africa': 'flag_rounded_africa_south-africa.svg ',
    'flag_rounded_africa_south-sudan': 'flag_rounded_africa_south-sudan.svg ',
    'flag_rounded_africa_sudan': 'flag_rounded_africa_sudan.svg ',
    'flag_rounded_africa_swaziland': 'flag_rounded_africa_swaziland.svg ',
    'flag_rounded_africa_tanzania': 'flag_rounded_africa_tanzania.svg ',
    'flag_rounded_africa_togo': 'flag_rounded_africa_togo.svg ',
    'flag_rounded_africa_tunisia': 'flag_rounded_africa_tunisia.svg ',
    'flag_rounded_africa_uganda': 'flag_rounded_africa_uganda.svg ',
    'flag_rounded_africa_western-sahara': 'flag_rounded_africa_western-sahara.svg ',
    'flag_rounded_africa_zambia': 'flag_rounded_africa_zambia.svg ',
    'flag_rounded_africa_zimbabwe': 'flag_rounded_africa_zimbabwe.svg ',
    'flag_rounded_asia_afghanistan': 'flag_rounded_asia_afghanistan.svg ',
    'flag_rounded_asia_armenia': 'flag_rounded_asia_armenia.svg ',
    'flag_rounded_asia_azerbaijan': 'flag_rounded_asia_azerbaijan.svg ',
    'flag_rounded_asia_bahrain': 'flag_rounded_asia_bahrain.svg ',
    'flag_rounded_asia_bangladesh': 'flag_rounded_asia_bangladesh.svg ',
    'flag_rounded_asia_bhutan-1': 'flag_rounded_asia_bhutan-1.svg ',
    'flag_rounded_asia_bhutan': 'flag_rounded_asia_bhutan.svg ',
    'flag_rounded_asia_british-indian-ocean-territory': 'flag_rounded_asia_british-indian-ocean-territory.svg ',
    'flag_rounded_asia_brunei': 'flag_rounded_asia_brunei.svg ',
    'flag_rounded_asia_cambodia': 'flag_rounded_asia_cambodia.svg ',
    'flag_rounded_asia_china': 'flag_rounded_asia_china.svg ',
    'flag_rounded_asia_christmas-island': 'flag_rounded_asia_christmas-island.svg ',
    'flag_rounded_asia_cocos-island': 'flag_rounded_asia_cocos-island.svg ',
    'flag_rounded_asia_cyprus': 'flag_rounded_asia_cyprus.svg ',
    'flag_rounded_asia_east-timor': 'flag_rounded_asia_east-timor.svg ',
    'flag_rounded_asia_georgia': 'flag_rounded_asia_georgia.svg ',
    'flag_rounded_asia_hong-kong': 'flag_rounded_asia_hong-kong.svg ',
    'flag_rounded_asia_india': 'flag_rounded_asia_india.svg ',
    'flag_rounded_asia_indonesia': 'flag_rounded_asia_indonesia.svg ',
    'flag_rounded_asia_iran': 'flag_rounded_asia_iran.svg ',
    'flag_rounded_asia_iraq': 'flag_rounded_asia_iraq.svg ',
    'flag_rounded_asia_israel': 'flag_rounded_asia_israel.svg ',
    'flag_rounded_asia_japan': 'flag_rounded_asia_japan.svg ',
    'flag_rounded_asia_jordan': 'flag_rounded_asia_jordan.svg ',
    'flag_rounded_asia_kazakhstan': 'flag_rounded_asia_kazakhstan.svg ',
    'flag_rounded_asia_kuwait': 'flag_rounded_asia_kuwait.svg ',
    'flag_rounded_asia_kyrgyzstan': 'flag_rounded_asia_kyrgyzstan.svg ',
    'flag_rounded_asia_laos': 'flag_rounded_asia_laos.svg ',
    'flag_rounded_asia_lebanon': 'flag_rounded_asia_lebanon.svg ',
    'flag_rounded_asia_macao': 'flag_rounded_asia_macao.svg ',
    'flag_rounded_asia_malaysia': 'flag_rounded_asia_malaysia.svg ',
    'flag_rounded_asia_maldives': 'flag_rounded_asia_maldives.svg ',
    'flag_rounded_asia_mongolia': 'flag_rounded_asia_mongolia.svg ',
    'flag_rounded_asia_myanmar': 'flag_rounded_asia_myanmar.svg ',
    'flag_rounded_asia_nepal': 'flag_rounded_asia_nepal.svg ',
    'flag_rounded_asia_north-korea': 'flag_rounded_asia_north-korea.svg ',
    'flag_rounded_asia_northen-cyprus': 'flag_rounded_asia_northen-cyprus.svg ',
    'flag_rounded_asia_northern-marianas-islands': 'flag_rounded_asia_northern-marianas-islands.svg ',
    'flag_rounded_asia_oman': 'flag_rounded_asia_oman.svg ',
    'flag_rounded_asia_ossetia': 'flag_rounded_asia_ossetia.svg ',
    'flag_rounded_asia_pakistan': 'flag_rounded_asia_pakistan.svg ',
    'flag_rounded_asia_palestine': 'flag_rounded_asia_palestine.svg ',
    'flag_rounded_asia_philippines': 'flag_rounded_asia_philippines.svg ',
    'flag_rounded_asia_qatar': 'flag_rounded_asia_qatar.svg ',
    'flag_rounded_asia_russia': 'flag_rounded_asia_russia.svg ',
    'flag_rounded_asia_saudi-arabia': 'flag_rounded_asia_saudi-arabia.svg ',
    'flag_rounded_asia_singapore': 'flag_rounded_asia_singapore.svg ',
    'flag_rounded_asia_south-korea': 'flag_rounded_asia_south-korea.svg ',
    'flag_rounded_asia_sri-lanka': 'flag_rounded_asia_sri-lanka.svg ',
    'flag_rounded_asia_syria': 'flag_rounded_asia_syria.svg ',
    'flag_rounded_asia_taiwan': 'flag_rounded_asia_taiwan.svg ',
    'flag_rounded_asia_tajikistan': 'flag_rounded_asia_tajikistan.svg ',
    'flag_rounded_asia_thailand': 'flag_rounded_asia_thailand.svg ',
    'flag_rounded_asia_tibet': 'flag_rounded_asia_tibet.svg ',
    'flag_rounded_asia_turkmenistan': 'flag_rounded_asia_turkmenistan.svg ',
    'flag_rounded_asia_united-arab-emirates': 'flag_rounded_asia_united-arab-emirates.svg ',
    'flag_rounded_asia_uzbekistan': 'flag_rounded_asia_uzbekistan.svg ',
    'flag_rounded_asia_vietnam': 'flag_rounded_asia_vietnam.svg ',
    'flag_rounded_asia_yemen': 'flag_rounded_asia_yemen.svg ',
    'flag_rounded_europe_abkhazia': 'flag_rounded_europe_abkhazia.svg ',
    'flag_rounded_europe_aland-islands': 'flag_rounded_europe_aland-islands.svg ',
    'flag_rounded_europe_albania': 'flag_rounded_europe_albania.svg ',
    'flag_rounded_europe_andorra': 'flag_rounded_europe_andorra.svg ',
    'flag_rounded_europe_austria': 'flag_rounded_europe_austria.svg ',
    'flag_rounded_europe_azores-islands': 'flag_rounded_europe_azores-islands.svg ',
    'flag_rounded_europe_balearic-islands': 'flag_rounded_europe_balearic-islands.svg ',
    'flag_rounded_europe_basque-country': 'flag_rounded_europe_basque-country.svg ',
    'flag_rounded_europe_belarus': 'flag_rounded_europe_belarus.svg ',
    'flag_rounded_europe_belgium': 'flag_rounded_europe_belgium.svg ',
    'flag_rounded_europe_bosnia-and-herzegovina': 'flag_rounded_europe_bosnia-and-herzegovina.svg ',
    'flag_rounded_europe_bulgaria': 'flag_rounded_europe_bulgaria.svg ',
    'flag_rounded_europe_canary-islands': 'flag_rounded_europe_canary-islands.svg ',
    'flag_rounded_europe_ceuta': 'flag_rounded_europe_ceuta.svg ',
    'flag_rounded_europe_corsica': 'flag_rounded_europe_corsica.svg ',
    'flag_rounded_europe_croatia': 'flag_rounded_europe_croatia.svg ',
    'flag_rounded_europe_czech-republic': 'flag_rounded_europe_czech-republic.svg ',
    'flag_rounded_europe_denmark': 'flag_rounded_europe_denmark.svg ',
    'flag_rounded_europe_england': 'flag_rounded_europe_england.svg ',
    'flag_rounded_europe_estonia': 'flag_rounded_europe_estonia.svg ',
    'flag_rounded_europe_faroe-islands': 'flag_rounded_europe_faroe-islands.svg ',
    'flag_rounded_europe_finland': 'flag_rounded_europe_finland.svg ',
    'flag_rounded_europe_france': 'flag_rounded_europe_france.svg ',
    'flag_rounded_europe_germany': 'flag_rounded_europe_germany.svg ',
    'flag_rounded_europe_gibraltar': 'flag_rounded_europe_gibraltar.svg ',
    'flag_rounded_europe_greece': 'flag_rounded_europe_greece.svg ',
    'flag_rounded_europe_greenland': 'flag_rounded_europe_greenland.svg ',
    'flag_rounded_europe_guernsey': 'flag_rounded_europe_guernsey.svg ',
    'flag_rounded_europe_hungary': 'flag_rounded_europe_hungary.svg ',
    'flag_rounded_europe_iceland': 'flag_rounded_europe_iceland.svg ',
    'flag_rounded_europe_ireland': 'flag_rounded_europe_ireland.svg ',
    'flag_rounded_europe_isle-of-man': 'flag_rounded_europe_isle-of-man.svg ',
    'flag_rounded_europe_italy': 'flag_rounded_europe_italy.svg ',
    'flag_rounded_europe_jersey': 'flag_rounded_europe_jersey.svg ',
    'flag_rounded_europe_kosovo': 'flag_rounded_europe_kosovo.svg ',
    'flag_rounded_europe_latvia': 'flag_rounded_europe_latvia.svg ',
    'flag_rounded_europe_liechtenstein': 'flag_rounded_europe_liechtenstein.svg ',
    'flag_rounded_europe_lithuania': 'flag_rounded_europe_lithuania.svg ',
    'flag_rounded_europe_luxembourg': 'flag_rounded_europe_luxembourg.svg ',
    'flag_rounded_europe_madeira': 'flag_rounded_europe_madeira.svg ',
    'flag_rounded_europe_malta': 'flag_rounded_europe_malta.svg ',
    'flag_rounded_europe_melilla': 'flag_rounded_europe_melilla.svg ',
    'flag_rounded_europe_moldova': 'flag_rounded_europe_moldova.svg ',
    'flag_rounded_europe_monaco': 'flag_rounded_europe_monaco.svg ',
    'flag_rounded_europe_montenegro': 'flag_rounded_europe_montenegro.svg ',
    'flag_rounded_europe_netherlands': 'flag_rounded_europe_netherlands.svg ',
    'flag_rounded_europe_norway': 'flag_rounded_europe_norway.svg ',
    'flag_rounded_europe_orkney-islands': 'flag_rounded_europe_orkney-islands.svg ',
    'flag_rounded_europe_poland': 'flag_rounded_europe_poland.svg ',
    'flag_rounded_europe_portugal': 'flag_rounded_europe_portugal.svg ',
    'flag_rounded_europe_republic-of-macedonia': 'flag_rounded_europe_republic-of-macedonia.svg ',
    'flag_rounded_europe_reunion-mayotte': 'flag_rounded_europe_reunion-mayotte.svg ',
    'flag_rounded_europe_romania': 'flag_rounded_europe_romania.svg ',
    'flag_rounded_europe_san-marino': 'flag_rounded_europe_san-marino.svg ',
    'flag_rounded_europe_sardinia': 'flag_rounded_europe_sardinia.svg ',
    'flag_rounded_europe_scotland': 'flag_rounded_europe_scotland.svg ',
    'flag_rounded_europe_serbia': 'flag_rounded_europe_serbia.svg ',
    'flag_rounded_europe_slovakia': 'flag_rounded_europe_slovakia.svg ',
    'flag_rounded_europe_slovenia': 'flag_rounded_europe_slovenia.svg ',
    'flag_rounded_europe_spain': 'flag_rounded_europe_spain.svg ',
    'flag_rounded_europe_st-pierre-and-miquelon': 'flag_rounded_europe_st-pierre-and-miquelon.svg ',
    'flag_rounded_europe_sweden': 'flag_rounded_europe_sweden.svg ',
    'flag_rounded_europe_switzerland': 'flag_rounded_europe_switzerland.svg ',
    'flag_rounded_europe_transnistria': 'flag_rounded_europe_transnistria.svg ',
    'flag_rounded_europe_turkey': 'flag_rounded_europe_turkey.svg ',
    'flag_rounded_europe_ukraine': 'flag_rounded_europe_ukraine.svg ',
    'flag_rounded_europe_united-kingdom': 'flag_rounded_europe_united-kingdom.svg ',
    'flag_rounded_europe_vatican-city': 'flag_rounded_europe_vatican-city.svg ',
    'flag_rounded_europe_wales': 'flag_rounded_europe_wales.svg ',
    'flag_rounded_northamerica_american-samoa': 'flag_rounded_northamerica_american-samoa.svg ',
    'flag_rounded_northamerica_anguilla': 'flag_rounded_northamerica_anguilla.svg ',
    'flag_rounded_northamerica_antigua-and-barbuda': 'flag_rounded_northamerica_antigua-and-barbuda.svg ',
    'flag_rounded_northamerica_bahamas': 'flag_rounded_northamerica_bahamas.svg ',
    'flag_rounded_northamerica_barbados': 'flag_rounded_northamerica_barbados.svg ',
    'flag_rounded_northamerica_belize': 'flag_rounded_northamerica_belize.svg ',
    'flag_rounded_northamerica_bermuda': 'flag_rounded_northamerica_bermuda.svg ',
    'flag_rounded_northamerica_bonaire': 'flag_rounded_northamerica_bonaire.svg ',
    'flag_rounded_northamerica_british-virgin-islands': 'flag_rounded_northamerica_british-virgin-islands.svg ',
    'flag_rounded_northamerica_canada': 'flag_rounded_northamerica_canada.svg ',
    'flag_rounded_northamerica_cayman-islands': 'flag_rounded_northamerica_cayman-islands.svg ',
    'flag_rounded_northamerica_costa-rica': 'flag_rounded_northamerica_costa-rica.svg ',
    'flag_rounded_northamerica_cuba': 'flag_rounded_northamerica_cuba.svg ',
    'flag_rounded_northamerica_curacao': 'flag_rounded_northamerica_curacao.svg ',
    'flag_rounded_northamerica_dominica': 'flag_rounded_northamerica_dominica.svg ',
    'flag_rounded_northamerica_dominican-republic': 'flag_rounded_northamerica_dominican-republic.svg ',
    'flag_rounded_northamerica_grenada': 'flag_rounded_northamerica_grenada.svg ',
    'flag_rounded_northamerica_guadalupe': 'flag_rounded_northamerica_guadalupe.svg ',
    'flag_rounded_northamerica_guam': 'flag_rounded_northamerica_guam.svg ',
    'flag_rounded_northamerica_guatemala': 'flag_rounded_northamerica_guatemala.svg ',
    'flag_rounded_northamerica_haiti': 'flag_rounded_northamerica_haiti.svg ',
    'flag_rounded_northamerica_hawaii': 'flag_rounded_northamerica_hawaii.svg ',
    'flag_rounded_northamerica_honduras': 'flag_rounded_northamerica_honduras.svg ',
    'flag_rounded_northamerica_jamaica': 'flag_rounded_northamerica_jamaica.svg ',
    'flag_rounded_northamerica_martinique': 'flag_rounded_northamerica_martinique.svg ',
    'flag_rounded_northamerica_mexico': 'flag_rounded_northamerica_mexico.svg ',
    'flag_rounded_northamerica_micronesia': 'flag_rounded_northamerica_micronesia.svg ',
    'flag_rounded_northamerica_montserrat': 'flag_rounded_northamerica_montserrat.svg ',
    'flag_rounded_northamerica_netherlands-antilles': 'flag_rounded_northamerica_netherlands-antilles.svg ',
    'flag_rounded_northamerica_nicaragua': 'flag_rounded_northamerica_nicaragua.svg ',
    'flag_rounded_northamerica_panama': 'flag_rounded_northamerica_panama.svg ',
    'flag_rounded_northamerica_puerto-rico': 'flag_rounded_northamerica_puerto-rico.svg ',
    'flag_rounded_northamerica_saba-island': 'flag_rounded_northamerica_saba-island.svg ',
    'flag_rounded_northamerica_saint-kitts-and-nevis': 'flag_rounded_northamerica_saint-kitts-and-nevis.svg ',
    'flag_rounded_northamerica_salvador': 'flag_rounded_northamerica_salvador.svg ',
    'flag_rounded_northamerica_sint-eustatius': 'flag_rounded_northamerica_sint-eustatius.svg ',
    'flag_rounded_northamerica_sint-maarten': 'flag_rounded_northamerica_sint-maarten.svg ',
    'flag_rounded_northamerica_st-barts': 'flag_rounded_northamerica_st-barts.svg ',
    'flag_rounded_northamerica_st-lucia': 'flag_rounded_northamerica_st-lucia.svg ',
    'flag_rounded_northamerica_st-vincent-and-the-grenadines': 'flag_rounded_northamerica_st-vincent-and-the-grenadines.svg ',
    'flag_rounded_northamerica_trinidad-and-tobago': 'flag_rounded_northamerica_trinidad-and-tobago.svg ',
    'flag_rounded_northamerica_turks-and-caicos': 'flag_rounded_northamerica_turks-and-caicos.svg ',
    'flag_rounded_northamerica_united-states': 'flag_rounded_northamerica_united-states.svg ',
    'flag_rounded_northamerica_virgin-islands': 'flag_rounded_northamerica_virgin-islands.svg ',
    'flag_rounded_oceania_australia': 'flag_rounded_oceania_australia.svg ',
    'flag_rounded_oceania_cook-islands': 'flag_rounded_oceania_cook-islands.svg ',
    'flag_rounded_oceania_fiji': 'flag_rounded_oceania_fiji.svg ',
    'flag_rounded_oceania_french-polynesia': 'flag_rounded_oceania_french-polynesia.svg ',
    'flag_rounded_oceania_kiribati': 'flag_rounded_oceania_kiribati.svg ',
    'flag_rounded_oceania_marshall-island': 'flag_rounded_oceania_marshall-island.svg ',
    'flag_rounded_oceania_nauru': 'flag_rounded_oceania_nauru.svg ',
    'flag_rounded_oceania_new-caledonia': 'flag_rounded_oceania_new-caledonia.svg ',
    'flag_rounded_oceania_new-zealand': 'flag_rounded_oceania_new-zealand.svg ',
    'flag_rounded_oceania_niue': 'flag_rounded_oceania_niue.svg ',
    'flag_rounded_oceania_norfolk-island': 'flag_rounded_oceania_norfolk-island.svg ',
    'flag_rounded_oceania_palau': 'flag_rounded_oceania_palau.svg ',
    'flag_rounded_oceania_papua-new-guinea': 'flag_rounded_oceania_papua-new-guinea.svg ',
    'flag_rounded_oceania_pitcairn-islands': 'flag_rounded_oceania_pitcairn-islands.svg ',
    'flag_rounded_oceania_rapa-nui': 'flag_rounded_oceania_rapa-nui.svg ',
    'flag_rounded_oceania_samoa': 'flag_rounded_oceania_samoa.svg ',
    'flag_rounded_oceania_solomon-islands': 'flag_rounded_oceania_solomon-islands.svg ',
    'flag_rounded_oceania_tokelau': 'flag_rounded_oceania_tokelau.svg ',
    'flag_rounded_oceania_tonga': 'flag_rounded_oceania_tonga.svg ',
    'flag_rounded_oceania_tuvalu': 'flag_rounded_oceania_tuvalu.svg ',
    'flag_rounded_oceania_vanuatu': 'flag_rounded_oceania_vanuatu.svg ',
    'flag_rounded_oceania_wallis-and-futuna': 'flag_rounded_oceania_wallis-and-futuna.svg ',
    'flag_rounded_others_columbia': 'flag_rounded_others_columbia.svg ',
    'flag_rounded_others_eu': 'flag_rounded_others_eu.svg ',
    'flag_rounded_others_nato': 'flag_rounded_others_nato.svg ',
    'flag_rounded_others_placeholder': 'flag_rounded_others_placeholder.svg ',
    'flag_rounded_others_united-nations': 'flag_rounded_others_united-nations.svg ',
    'flag_rounded_southamerica_argentina': 'flag_rounded_southamerica_argentina.svg ',
    'flag_rounded_southamerica_aruba': 'flag_rounded_southamerica_aruba.svg ',
    'flag_rounded_southamerica_bolivia': 'flag_rounded_southamerica_bolivia.svg ',
    'flag_rounded_southamerica_brazil': 'flag_rounded_southamerica_brazil.svg ',
    'flag_rounded_southamerica_chile': 'flag_rounded_southamerica_chile.svg ',
    'flag_rounded_southamerica_colombia': 'flag_rounded_southamerica_colombia.svg ',
    'flag_rounded_southamerica_ecuador': 'flag_rounded_southamerica_ecuador.svg ',
    'flag_rounded_southamerica_falkland-islands': 'flag_rounded_southamerica_falkland-islands.svg ',
    'flag_rounded_southamerica_french-guiana': 'flag_rounded_southamerica_french-guiana.svg ',
    'flag_rounded_southamerica_galapagos-islands': 'flag_rounded_southamerica_galapagos-islands.svg ',
    'flag_rounded_southamerica_guyana': 'flag_rounded_southamerica_guyana.svg ',
    'flag_rounded_southamerica_paraguay': 'flag_rounded_southamerica_paraguay.svg ',
    'flag_rounded_southamerica_peru': 'flag_rounded_southamerica_peru.svg ',
    'flag_rounded_southamerica_suriname': 'flag_rounded_southamerica_suriname.svg ',
    'flag_rounded_southamerica_uruguay': 'flag_rounded_southamerica_uruguay.svg ',
    'flag_rounded_southamerica_venezuela': 'flag_rounded_southamerica_venezuela.svg ',
    'icon_nature_no-lightening': 'icon_nature_no-lightening.svg',
    'icon_documents_upload-document': 'icon_documents_upload-document.svg',
    // samsung
    'icon_basic_hor_alt': 'icon_basic_hor_alt.svg',
    'icon_basic_hor': 'icon_basic_hor.svg',
    'icon_basic_ver_alt': 'icon_basic_ver_alt.svg',
    'icon_basic_ver': 'icon_basic_ver.svg',
    'icon_hor_alt': 'icon_hor_alt.svg',
    'icon_hor': 'icon_hor.svg',
    'icon_ver_alt': 'icon_ver_alt.svg',
    'icon_ver': 'icon_ver.svg',
};
export { IconsFoundationsZiniaThemes };
//# sourceMappingURL=icons-foundations.zinia.themes.js.map